import store from 'store/storeConfig';

import { getConditionValue, getPreference } from './Helpers/Patient';

export const getNewCondition = (conditionKey: string, remove = false) => {
  const { intl } = store.getState();
  const propertyName = getPreference(conditionKey);
  const newCondition: ICondition = {
    [propertyName]: remove ? null : getConditionValue(conditionKey, intl),
    condition: conditionKey
  };
  return newCondition;
};
